module.exports = __webpack_public_path__ + "img/credit-card-icon.8f11785c.svg";